import React from 'react';
import { SearchIcon } from 'lucide-react';
export function SearchBar() {
  return <div className="w-full bg-[#F5F7F8] py-8 border-b border-[#E0E0E0]" data-id="element-61">
      <div className="max-w-6xl mx-auto px-4" data-id="element-62">
        <div className="max-w-3xl" data-id="element-63">
          <div className="relative flex items-center w-full" data-id="element-64">
            <div className="absolute left-4 text-gray-400" data-id="element-65">
              <SearchIcon className="w-5 h-5" data-id="element-66" />
            </div>
            <input type="text" defaultValue="Khoanh Nam Ta" className="w-full h-12 pl-12 pr-4 bg-white border border-[#E0E0E0] rounded shadow-sm focus:outline-none focus:border-[#2E7D32] focus:ring-1 focus:ring-[#2E7D32] text-lg font-sans text-gray-900" placeholder="Search publications, authors, or subjects..." data-id="element-67" />
            <button className="absolute right-2 h-8 px-4 bg-[#2E7D32] hover:bg-[#1B5E20] text-white text-sm font-medium rounded transition-colors" data-id="element-68">
              Search
            </button>
          </div>

          <div className="flex items-center gap-1 mt-3 border-b border-[#E0E0E0]" data-id="element-69">
            <button className="px-4 py-2 text-sm font-medium text-[#2E7D32] border-b-2 border-[#2E7D32] bg-white" data-id="element-70">
              Author
            </button>
            <button className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors" data-id="element-71">
              Title
            </button>
            <button className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors" data-id="element-72">
              Subject
            </button>
          </div>

          <div className="mt-4 text-sm text-gray-600" data-id="element-73">
            Showing results for author:{' '}
            <span className="font-semibold text-gray-900" data-id="element-74">Khoanh Nam Ta</span>
          </div>
        </div>
      </div>
    </div>;
}